import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Lock } from 'lucide-react';

export default function NewPasswordStep({
  newPassword, setNewPassword,
  confirmPassword, setConfirmPassword,
  loading, onSubmit,
}) {
  const mismatch = confirmPassword.length > 0 && newPassword !== confirmPassword;
  const tooShort = newPassword.length > 0 && newPassword.length < 8;

  return (
    <form onSubmit={onSubmit} className="space-y-5" data-testid="forgot-password-step">
      <p className="text-sm text-emerald-700">
        Set a new password for your admin account. You'll be redirected to log in after saving.
      </p>

      <div>
        <Label htmlFor="new-password" className="uppercase text-xs font-bold text-muted-foreground mb-1.5 block">
          New Password
        </Label>
        <div className="relative">
          <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
          <Input
            id="new-password"
            data-testid="new-password-input"
            type="password"
            placeholder="At least 8 characters"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="h-14 rounded-2xl bg-secondary border-transparent pl-12"
            required
            autoFocus
          />
        </div>
        {tooShort && <p className="text-xs text-red-600 mt-1">Must be at least 8 characters.</p>}
      </div>

      <div>
        <Label htmlFor="confirm-password" className="uppercase text-xs font-bold text-muted-foreground mb-1.5 block">
          Confirm Password
        </Label>
        <div className="relative">
          <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
          <Input
            id="confirm-password"
            data-testid="confirm-password-input"
            type="password"
            placeholder="Re-enter new password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="h-14 rounded-2xl bg-secondary border-transparent pl-12"
            required
          />
        </div>
        {mismatch && <p className="text-xs text-red-600 mt-1">Passwords do not match.</p>}
      </div>

      <Button
        type="submit"
        data-testid="reset-password-submit-button"
        className="w-full btn-volt h-14"
        disabled={loading || newPassword.length < 8 || newPassword !== confirmPassword}
      >
        {loading ? 'Saving...' : 'Set new password'}
      </Button>
    </form>
  );
}
